import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;
const TypographyDEMO = () => (
    <Title level={2}>h2. Ant Design</Title>
);
export default TypographyDEMO;